import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'keys',
    standalone: false,
})
export class KeysPipe implements PipeTransform {
    transform(value: any): any {
        let keys = [];
        for (let key in value) {
            keys.push(key);
        }
        return keys;
    }
}
